/**
 * Per-phrase freshness, sourced from each markdown file's last git commit date
 * (baked into freshness.json by scripts/gen-freshness.js at build time). Drives
 * the "Updated <Month Year>" badge.
 */
import freshnessJson from './freshness.json';

const MAP = freshnessJson as Record<string, string>;

/** ISO date (YYYY-MM-DD) for a markdown path relative to src/markdown, sans .md. */
export function updatedDate(relNoExt: string): string {
  return MAP[relNoExt] || '';
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "May 2026" — empty string for missing/invalid dates. */
export function formatUpdated(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}
